import React from "react";
import styled from "styled-components";
import Cover from "./assets/password-cover.svg";
import WhiteLogo from "./assets/white-logo.svg";

/**
 * 正式模考中途離開，這一科被鎖住時整頁換成這個。
 *
 * 刻意不提供「繼續」或「重新整理」的按鈕——鎖定要由教務人員在後台解除，
 * 給學生自救的路等於這條規則沒有意義。已經寫下的答案不會消失。
 */

const StyledLocked = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  background-image: url(${Cover});
  background-size: 100%;
  background-repeat: repeat-y;
  font-family: Arial, "Noto Sans TC", sans-serif;

  .inner {
    max-width: 620px;
    margin: 0 auto;
    padding: 12vh 24px;
  }
  .logo {
    display: block;
    width: 240px;
    max-width: 60%;
    margin: 0 auto 32px;
  }
  .sheet {
    background: rgba(255, 255, 255, 0.97);
    color: #1d2430;
    border-radius: 10px;
    padding: 32px;
    text-align: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
    border-top: 6px solid #a8432a;
  }
  h1 {
    font-size: 22px;
    margin: 0 0 6px;
    color: #a8432a;
  }
  .en {
    color: #5b6774;
    font-size: 15px;
    margin: 0 0 20px;
  }
  p {
    font-size: 15px;
    line-height: 1.9;
    margin: 0 0 10px;
  }
  .quiet {
    color: #5b6774;
    font-size: 14px;
    margin-top: 18px;
  }
`;

const LockedNotice = ({ reason }) => (
  <StyledLocked>
    <div className="inner">
      <img className="logo" src={WhiteLogo} alt="Churchill English" />
      <div className="sheet">
        <h1>測驗已中斷</h1>
        <p className="en">This test has been suspended.</p>
        <p>
          系統偵測到你在作答期間離開了測驗畫面
          {reason ? `（${reason}）` : ""}。
        </p>
        <p>
          正式模擬考不允許中途離開，這一科已暫停。
          <br />
          請聯絡教務人員解鎖後才能繼續作答。
        </p>
        <p className="quiet">
          你已經作答的內容都有保留。解鎖後回到這一科，會回到中斷前的那一頁，
          計時器也接著剩下的時間繼續跑。
        </p>
      </div>
    </div>
  </StyledLocked>
);

export default LockedNotice;
